import React from "react";
import styled from "styled-components";
import {isContainedIn, PerformancePeriod, RewardPeriods} from "../../performance/period";
import Metric, {MetricValue} from "./Metric";
import {subduedTextColour} from "../../../style/styleConsts";
import {IsoFields} from "js-joda";
import {months} from "../../../util/timeDescription";


const ddMMMyyyy = (date) => {
    return `${date.dayOfMonth()} ${months[date.monthValue() - 1]} ${date.year()}`;
};

const MMMyyyy = (date) => {
    return `${months[date.monthValue() - 1]} ${date.year()}`;
};

const PerformancePeriodComponents = {
    MonthToDate:    {
        rewardPeriod: RewardPeriods.Month,
        labelsForRetrospectivePeriod(rewardStartDate) {
            return { duration: `${months[rewardStartDate.monthValue() - 1]} ${rewardStartDate.year()}`, end: null };
        }
    },
    QuarterToDate:  {
        rewardPeriod: RewardPeriods.Quarter,
        labelsForRetrospectivePeriod(rewardStartDate) {
            return { duration: `Q${rewardStartDate.get(IsoFields.QUARTER_OF_YEAR)} ${rewardStartDate.year()}`, end: null};
        }
    },
    YearToDate:     {
        rewardPeriod: RewardPeriods.Year,
        labelsForRetrospectivePeriod(rewardStartDate) {
            return { duration: `${rewardStartDate.year()}`, end: null };
        }
    },

    SevenDaysToDate: {
        rewardPeriod: RewardPeriods.Month,
        labelsForRetrospectivePeriod(rewardStartDate) {
            const endDate = RewardPeriods.Month.endDate(rewardStartDate);
            return { duration: "7 Days", end: `to ${ddMMMyyyy(endDate)}` };
        }
    },
    ThirtyDaysToDate: {
        rewardPeriod: RewardPeriods.Month,
        labelsForRetrospectivePeriod(rewardStartDate) {
            const endDate = RewardPeriods.Month.endDate(rewardStartDate);
            return { duration: "30 Days", end: `to ${ddMMMyyyy(endDate)}` };
        }
    },

    ThreeMonthsToDate: {
        rewardPeriod: RewardPeriods.Quarter,
        labelsForRetrospectivePeriod(rewardStartDate) {
            const endDate = RewardPeriods.Quarter.endDate(rewardStartDate);
            return { duration: "3 Months", end: `to ${MMMyyyy(endDate)}` };
        }
    },
    SixMonthsToDate: {
        rewardPeriod: RewardPeriods.Quarter,
        labelsForRetrospectivePeriod(rewardStartDate) {

            const endDate = RewardPeriods.Quarter.endDate(rewardStartDate);
            return { duration: "6 Months", end: `to ${MMMyyyy(endDate)}` };
        }
    },
    InceptionToDate: {
        rewardPeriod: RewardPeriods.Quarter,
        labelsForRetrospectivePeriod(rewardStartDate) {

            const endDate = RewardPeriods.Quarter.endDate(rewardStartDate);
            return { duration: "Since Inception", end: `to ${ddMMMyyyy(endDate)}` };
        }
    },

    TwelveMonthsToDate: {
        rewardPeriod: RewardPeriods.Year,
        labelsForRetrospectivePeriod(rewardStartDate) {

            const endDate = RewardPeriods.Year.endDate(rewardStartDate);
            return { duration: "12 Months", end: `to ${MMMyyyy(endDate)}` };
        }
    }
};

export const PeriodDurationText = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
`;

const PeriodEndText = styled.div`
    color: ${subduedTextColour};
`;


function retrospectiveComponent(periodComponent, rewardStartDate) {
    const labels = periodComponent.labelsForRetrospectivePeriod(rewardStartDate);
    return (
        <PeriodDurationText>
            <MetricValue>{labels.duration}</MetricValue>
            {labels.end ? <PeriodEndText>&nbsp;{labels.end}</PeriodEndText> : ""}
        </PeriodDurationText>
    );
}

const PeriodMetric = ({performancePeriodBasis, rewardStartDate, viewingOnDate}) => {
    if (!performancePeriodBasis || !rewardStartDate) {
        return "";
    }

    const periodComponent = PerformancePeriodComponents[performancePeriodBasis];
    const rewardPeriod = periodComponent.rewardPeriod;

    const valueComponent = isContainedIn(rewardStartDate, rewardPeriod.endDate(rewardStartDate), viewingOnDate)
        ? <MetricValue>{PerformancePeriod[performancePeriodBasis].activeLabel}</MetricValue>
        : retrospectiveComponent(periodComponent, rewardStartDate);

    return (
        <Metric className="t-period-metric"
                label={"Performance Period"}>
            {valueComponent}
        </Metric>
    );
};

export default PeriodMetric;
